// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ingress-status-ingress-status-652bb{width:315px}.ingress-status-ingress-status-652bb .ingress-status-edit-icon-0e0a9{margin-left:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ingress-status": "ingress-status-ingress-status-652bb",
	"ingressStatus": "ingress-status-ingress-status-652bb",
	"edit-icon": "ingress-status-edit-icon-0e0a9",
	"editIcon": "ingress-status-edit-icon-0e0a9"
};
export default ___CSS_LOADER_EXPORT___;
